import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M15 9H5a1 1 0 1 0 0 2h10a1 1 0 1 0 0-2",
  fillRule: "evenodd"
});

var SvgMinusMinor = function SvgMinusMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export { SvgMinusMinor as S };
